// extracted by mini-css-extract-plugin
module.exports = {"flex":"InlineBlock__flex--TYlTM","box":"InlineBlock__box--1l_fg"};